export class EligibilityPayloadModel {
    haveInsurance: boolean;
    products: any;
    captionUserType?: string;
}

export class EligibilityQuestionModel {
    wsg_question_id: string;
    sci_question_id: string;
    text: string;
    agentText: string;
    optional_text: string;
    value: any;
    optional_value: any;
    tooltip: any;
    required: string;
    type: number;
    parent_question_id: any;
    parent_trigger_value: any;
    products: any[];
    classes: any;
    losshistory: any;
}
